import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "tabs-container" }
const _hoisted_2 = { class: "tabs-header" }
const _hoisted_3 = { class: "tabs-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
        return (_openBlock(), _createBlock(_component_Button, {
          key: tab.id,
          className: _ctx.activeTabId === tab.id ? 'blueBtn' : 'whiteBtn',
          onClick: () => _ctx.$emit('update:activeTabId', tab.id),
          text: _ctx.$t(tab.label),
          class: "tab-button"
        }, null, 8, ["className", "onClick", "text"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ]))
}